import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import {
	CUSTOM_BREAKPOINT_470,
	CUSTOM_BREAKPOINT_980,
} from 'shared/custom/constants/commonConstants';

export const useVisibleSlides = () => {
	const theme = useTheme();
	const xlMatch = useMediaQuery(theme.breakpoints.up('xl'));
	const lgMatch = useMediaQuery(theme.breakpoints.up('lg'));
	const mdMatch = useMediaQuery(theme.breakpoints.up('md'));
	const smMatch = useMediaQuery(theme.breakpoints.up('sm'));
	const xsMatch = useMediaQuery(theme.breakpoints.up('xs'));

	const sMmDMatch = useMediaQuery(theme.breakpoints.down(CUSTOM_BREAKPOINT_470));
	const lgMdMatch = useMediaQuery(theme.breakpoints.down(CUSTOM_BREAKPOINT_980));

	const visibleSlides = useMemo(
		() => (xlMatch ? 4.2 : lgMatch ? 4.2 : mdMatch ? 3.5 : smMatch ? 1.2 : 1.2),
		[xlMatch, lgMatch, mdMatch, smMatch, xsMatch]
	);

	const step = useMemo(
		() => (xlMatch ? 4 : lgMatch ? 4 : mdMatch ? 3 : smMatch ? 1 : 1),
		[xlMatch, lgMatch, mdMatch, smMatch, xsMatch]
	);

	return { visibleSlides, step, sMmDMatch, lgMdMatch, lgMatch };
};
